import { Box, Typography } from "@mui/material";
import { extractArrayFromManyToMany } from "../../utils";

export type FrequencyBand = {
    id: number;
    name: string;
};

type FrequencyBandsProps = {
    frequencyBands: FrequencyBand[];
};
export const FrequencyBands = ({ frequencyBands }: FrequencyBandsProps) => {
    const extractedFrequencyBands = extractArrayFromManyToMany(frequencyBands, "frequency_bands") as FrequencyBand[];
    return (
        <Box sx={{ display: "flex", flexDirection: "row", gap: 1, mb: 2 }}>
            {extractedFrequencyBands.map((frequencyBand) => (
                <Typography key={frequencyBand.name} variant="body1">
                    {frequencyBand.name}
                </Typography>
            ))}
        </Box>
    );
};
